var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"botao-menu",attrs:{"type":_vm.tipo}},[_c('i',{class:_vm.font_awesome_class}),_vm._v(" "+_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }